export default "__VITE_ASSET__BqLcSeh7__"